(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Close the horizontal collection dropdown when clicking outside of it */
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.facets--horizontal .facets__panel--collections[open]').forEach((panel) => {
      if (!panel.contains(event.target)) panel.removeAttribute('open');
    });
  });

  /* Product slider: shows one product at a time and rotates on a timer */
  if (!customElements.get('filter-product-slider')) {
    class FilterProductSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.timer = null;
        this.delay = Number(this.dataset.interval) || 5000;

        if (this.slides.length < 2) return;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.show(i);
            this.start();
          });
        });

        this.onPause = () => this.stop();
        this.onResume = () => this.start();
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());

        this.addEventListener('mouseenter', this.onPause);
        this.addEventListener('mouseleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      show(next) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      }
    }

    customElements.define('filter-product-slider', FilterProductSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
